import clsx from "clsx";
import styles from "./styles.module.scss";

interface IToggleButton {
  data: [React.ReactElement, React.ReactElement];
  isNoneFlex?: boolean;
}

const ToggleButton = ({ data, isNoneFlex }: IToggleButton) => {
  return (
    <div className={styles.toggleButton}>
      <div
        className={clsx(
          styles.toggleButton__container,
          isNoneFlex && styles.toggleButton__container_noneFlex
        )}
      >
        <div className={styles.toggleButton__buttons}>
          <div className={styles.toggleButton__firstItem}>{data[0]}</div>
          <div className={styles.toggleButton__secondItem}>{data[1]}</div>
        </div>
      </div>
    </div>
  );
};

export default ToggleButton;
